import { useVersionChecker } from "../../hooks/useVersionChecker.tsx";

export default function VersionChecker() {
  // Hook runs automatically and handles reloading - no UI needed
  useVersionChecker();
  
  // Return null since automatic reload handles everything
  return null;
}
